/**
 * The backend's banner size ids and their labels.
 *
 * `bannerSizeLabel(id)` for a value off a record — `''` for no size, so a cell can stay
 * empty. A form offers `PUBLISHER_BANNER_SIZE_IDS`, never every key of the map: the API
 * accepts forty sizes and a publisher is sold five.
 */
export const BannerSize = {
  Size12090: 2,
  Size250250: 13,
  Size300250: 14,
  Size46860: 18,
  Size72890: 19,
  Size300100: 27,
  Size900250: 31,
  Adaptive: 33
} as const

export type BannerSizeId = (typeof BannerSize)[keyof typeof BannerSize]

export const BannerSizeLabels: Record<number, string> = {
  [BannerSize.Size12090]: '120x90',
  [BannerSize.Size250250]: '250x250',
  [BannerSize.Size300250]: '300x250',
  [BannerSize.Size46860]: '468x60',
  [BannerSize.Size72890]: '728x90',
  [BannerSize.Size300100]: '300x100',
  [BannerSize.Size900250]: '900x250',
  [BannerSize.Adaptive]: 'Adaptive'
}

export function bannerSizeLabel(sizeId?: number | null): string {
  if (sizeId == null) return ''

  return BannerSizeLabels[sizeId] ?? String(sizeId)
}

export const PUBLISHER_BANNER_SIZE_IDS = [
  BannerSize.Size300100,
  BannerSize.Size300250,
  BannerSize.Size12090,
  BannerSize.Size72890,
  BannerSize.Adaptive
] as const
